


































import '@/assets/css/components/filter.scss';

import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import FilterModule from '@/store/modals/filter';

import { FilterPreviewEntryInterface } from '@/types/filter/filterPreviewEntry';
import { FilterSettings } from '@/types/filter/filter';

library.add(faTimes);

interface FilterValueInterface {
    name: string,
    value: boolean | string,
    iconClass: string,
    iterable: boolean,
    displayValue?: string,
}

interface filterPreviewsProcessed {
    [key: string]: FilterValueInterface,
}

@Component({
    components: {
        FontAwesomeIcon,
    },
})
export default class FilterPreview extends Vue {
    @Prop({ required: true }) readonly filterPreview!: FilterSettings['filterPreview'];
    @Prop({ required: true }) readonly filterModel!: FilterSettings['filterModel'];
    @Prop({ required: false }) readonly action?: string;

    filterPreviewsProcessed: filterPreviewsProcessed = {};
    hasHiddenPreviews = false;

    get isShow() {
        return FilterModule.modal.isShow;
    }

    async removeSelected(key: string) {
        if (typeof this.action === 'string') {
            await this.$store.dispatch(this.action, key);
            this.$forceUpdate();
            this.$emit('updateList');
        }
    }

    @Watch('filterPreview')
    async onFilterPreviewChange(value: Record<string, unknown>) {
        if (!value) {
            return;
        }

        await this.setSortedPreviews(value);
        this.$nextTick(this.hidePreviews);
    }

    setSortedPreviews(previews: Record<string, unknown>) {
        let values = Object.entries(previews);
        values = values.sort(this.sortCallback as any);
        values.forEach(([name, val]) => {
          if (this.filterModel[name]) {
            (val as any).value = this.filterModel[name].value;
          }
        });

        this.filterPreviewsProcessed = Object.fromEntries(values) as filterPreviewsProcessed;
    }

    hidePreviews() {
        const previewWrapper = this.$el as HTMLElement;
        const maxWidth = previewWrapper.offsetWidth - 65;

        const previews = document.getElementsByClassName('mr-filter-preview');
        const previewsArray = Array.from(previews) as HTMLElement[];

        previewsArray.forEach(item => {
            if (item.offsetLeft + item.offsetWidth > maxWidth) {
                this.hasHiddenPreviews = true;
                item.classList.add('hidden');

                return;
            }
            if (item.classList.contains('hidden')) {
                item.classList.remove('hidden');
            }
            this.hasHiddenPreviews = false;
        });
    }

    sortCallback(a: FilterPreviewEntryInterface[], b: FilterPreviewEntryInterface[]) {
        return Number(a[1].iterable) - Number(b[1].iterable);
    }

    getFilterPreviewValue(filterValue: FilterValueInterface) {
        if (filterValue.displayValue) {
            return filterValue.displayValue;
        }

        if (!filterValue.value || typeof filterValue.value === 'boolean') {
            return filterValue.name;
        }

        return filterValue.value;
    }

    mounted() {
        if (!this.filterPreview) {
            return;
        }
        this.setSortedPreviews(this.filterPreview);
    }
}
